<template>
  <el-dialog
    v-if="this.isCreate() || this.isUpdate()"
    width="71%"
    top="2%"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :title="titleModal"
    :visible.sync="internalVisible"
    @close="handleClose()"
  >
    <loading
      :active.sync="isLoadingSubzone"
      :can-cancel="false"
      :color="'#f18f00'"
      :is-full-page="false"
      :height="100"
      :width="255"
      :opacity="0.8"
    >
    </loading>
    <div class="row">
      <div class="col-12">
        <span style="font-size: 15px; word-break: break-word">
          1. {{ $t('common_words.subzone_info_message') }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          clearable
          @clear="pagination.perPage = 5"
          class="select-default mb-3 shadow-sm"
          style="width: 200px"
          v-model="pagination.perPage"
          :placeholder="$t('common_words.per_page')"
          filterable
        >
          <el-option
            class="select-default"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-input
          clearable
          class="mb-3 shadow-sm"
          style="width: 200px"
          :placeholder="$t('common_words.search_records')"
          v-model="searchQuery"
          aria-controls="datatables"
        />
      </div>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
      >
        <div class="col-12">
          <div class="row my-2">
            <div class="col-12 pr-0">
              <a @click="addSubzoneRow" style="cursor: pointer">
                <em class="fa fa-plus" style="color: #2891b0"></em
                >{{ $t('common_words.add_record') }}
              </a>
            </div>
          </div>
          <el-table
            v-if="queriedData.length > 0 || addSubzone == 0"
            style="width: 100%"
            :data="queriedData"
            :border="true"
          >
            <el-table-column
              prop="businesses_id"
              :label="`${$t('common_words.companies2')}`"
            >
              <template slot-scope="scope">
                <el-select
                  @change="
                    selectAllFromSelect(
                      scope.row.businesses_id,
                      businesses,
                      scope
                    )
                  "
                  clearable
                  multiple
                  collapse-tags
                  class="select-primary custom-width-select nut-rels shadow-sm"
                  size="large"
                  v-model="scope.row.businesses_id"
                  :placeholder="`${$t('common_words.select')}...`"
                  filterable
                >
                  <el-option
                    v-for="(option, index) in businesses"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id + '_' + index"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="zone_id" :label="$t('common_words.zones')">
              <template slot-scope="scope">
                <el-select
                  clearable
                  class="select-primary custom-width-select nut-rels shadow-sm"
                  size="large"
                  v-model="scope.row.zone_id"
                  :placeholder="`${$t('common_words.select')}...`"
                  filterable
                >
                  <el-option
                    v-for="(option, index) in zones"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id + '_' + index"
                  ></el-option>
                </el-select> </template
            ></el-table-column>
            <el-table-column prop="name" :label="$t('common_words.name')">
              <template slot-scope="scope">
                <el-input
                  maxlength="60"
                  show-word-limit
                  clearable
                  size="small"
                  style="text-align: center"
                  v-model="scope.row.name"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="30"
              :label="$t('common_words.actions')"
            >
              <template slot-scope="scope">
                <a
                  v-if="isCreate()"
                  :finish-button-text="$t('common_words.save')"
                  class="btn-success btn-simple btn-link actions-box-category-save"
                  @click="storeUpdateSubzone(scope.$index, scope.row, true)"
                  ><em class="fa fa-floppy-o"></em>
                </a>
                <a
                  v-if="addSubzone > 1 && isDelete()"
                  v-tooltip.top-center="$t('common_words.delete')"
                  class="btn-danger btn-simple btn-link"
                  slot="reference"
                  @click="deleteSubzone(scope.$index, scope.row, true)"
                >
                  <em class="fa fa-times"></em>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <p class="card-category" style="font-size: 14px">
            {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
            {{ to }} {{ $t('table2.of') }} {{ total }}
            {{ $t('table2.entries') }}
          </p>
        </div>
        <l-pagination
          class="pagination-no-border"
          ref="paginationSubzone"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
          pageFirst="false"
          pageLast="false"
        >
        </l-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import Loading from 'vue-loading-overlay';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create-subzone',
  props: {
    subzoneCreation: { type: Boolean, default: false },
    titleModal: { type: String, default: '' },
  },
  components: {
    Loading,
  },
  data() {
    return {
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      businesses: [],
      zones: [],
      isLoadingSubzone: false,
      addSubzone: 0,
      subzoneForm: {
        businesses_id: [],
        businesses_names: [],
        name: null,
        zone_id: null,
      },
    };
  },
  mixins: [
    mixinMasters,
    MixinLoading,
    MixinPermissions,
    MixinAlert,
    MixinNotification,
  ],
  computed: {
    internalVisible: {
      get() {
        return this.subzoneCreation;
      },
      set(val) {
        this.$emit('update:subzoneCreation', val);
      },
    },
    queriedData() {
      let result = this.tableData;
      if (this.searchQuery !== '') {
        result = this.fuseSearch.search('=' + this.searchQuery + '');
      }
      this.pagination.total = result.length;

      return result.slice(this.from, this.to);
    },
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }

      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;

      return this.tableData.length;
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:subzoneCreation', false);
    },
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    searchFuse(keys) {
      this.fuseSearch = new Fuse(this.tableData, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: keys,
      });
      this.showHideLoading();
    },
    addSubzoneRow() {
      let newRow = { type: '', visible: false };
      this.tableData = [...this.tableData, newRow];
      ++this.addSubzone;
      setTimeout(() => {
        this.pagination.currentPage = this.$refs.paginationSubzone.maxPage;
      }, 150);
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    updateBusinessSelect() {
      this.tableData.forEach((subzone, index) => {
        if (isset(subzone.businesses) && subzone.businesses.length > 0) {
          const businessIds = subzone.businesses.map((b) => b.id);
          this.$set(this.tableData[index], 'businesses_id', businessIds);
        } else {
          this.tableData.splice(index, 1);
        }
      });
    },
    storeUpdateSubzone(index, row, closeModal = false) {
      if (
        isset(row.name) &&
        row.businesses_id.length > 0 &&
        isset(row.zone_id)
      ) {
        this.isLoadingSubzone = true;
        this.subzoneForm = row;
        this.subzoneForm.route = 'subzone';
        this.subzoneForm.businesses_names = this.getNameOfData(
          this.subzoneForm.businesses_id,
          this.businesses
        );

        if (isset(row.id)) {
          Axios.updateMaster(this.subzoneForm)
            .then((response) => {
              let indexRow = this.tableData.findIndex(
                (tableRow) => tableRow.id === this.subzoneForm.id
              );
              this.$set(this.tableData, indexRow, response.data.data);
              this.isLoadingSubzone = false;
              this.updateBusinessSelect();
              if (closeModal) this.handleClose();
              SweetAlert.success(response.data.message);
              this.$emit('subzonesUpdate', this.tableData);

              return true;
            })
            .catch((error) => {
              if (closeModal) this.handleClose();
              this.showMessageErrors(error);

              return false;
            });
        } else {
          Axios.saveMaster(this.subzoneForm)
            .then((response) => {
              this.$set(this.tableData, index, {
                ...response.data.data,
              });
              this.updateBusinessSelect();
              this.isLoadingSubzone = false;
              if (closeModal) this.handleClose();
              SweetAlert.success(response.data.message);
              this.$emit('subzonesUpdate', this.tableData);

              return true;
            })
            .catch((error) => {
              if (closeModal) this.handleClose();
              this.showMessageErrors(error);
              return false;
            });
        }
      }
    },
    deleteSubzone(index, row) {
      if (isset(row.id)) {
        this.subzoneForm = row;
        this.subzoneForm.route = 'subzone';
        this.subzoneForm.id = row.id;
        SweetAlert.delete(i18n.t('common_words.subzone')).then((result) => {
          if (result.value) {
            this.isLoadingSubzone = true;
            Axios.destroyMaster(this.subzoneForm)
              .then((response) => {
                SweetAlert.success(i18n.t('common_words.successful_deletion'));
                this.tableData = response.data.data;
                this.updateBusinessSelect();
                this.$emit('subzonesUpdate', this.tableData);
              })
              .catch((error) => {
                this.showMessageErrors(error);
              });
            this.isLoadingSubzone = false;
            this.tableData.splice(index, 1);
            this.addSubzone--;
          }
        });
      } else {
        this.tableData.splice(index, 1);
        this.addSubzone--;
      }
    },
  },
  mounted() {
    this.isLoadingSubzone = true;
    Promise.all([
      Axios.getMasters('businesses/only'),
      Axios.getMasters('zones'),
      Axios.getMasters('subzone'),
    ])
      .then(([responseBusinesses, responseZones, responseSubzones]) => {
        this.businesses = this.concatAll(responseBusinesses.data.data);
        this.zones = responseZones.data.data;
        this.tableData = responseSubzones.data.data;
        if (this.tableData.length > 0) {
          this.addSubzone = this.tableData.length;
          this.updateBusinessSelect();
          this.searchFuse(['name']);
        }
        this.showHideLoading();
        this.isLoadingSubzone = false;
      })
      .catch((error) => this.showMessageErrors(error));
  },
};
</script>
